module.exports = __webpack_public_path__ + "img/default_img14.f371bea5.webp";